import { SET_TOKEN, LOGOUT, SET_ME } from "../actions/authActions";

const validateToken = (token: string | null): string | null => {
    if (!token) return null;
    
    try {
        // Check if token is expired
        const decoded: any = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Date.now() / 1000;
        
        if (decoded.exp && decoded.exp < currentTime) {
            localStorage.removeItem('token');
            return null;
        }
        
        return token;
    } catch (error) {
        localStorage.removeItem('token');
        return null;
    }
};

const initialState: AuthReducerState = {
    token: validateToken(localStorage.getItem('token')),
    me: null,
    error: ''
}

const authReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_TOKEN:
            return {
                ...state,
                token: action.value,
            }
        case SET_ME:
            return {
                ...state,
                me: action.value
            }
        case LOGOUT:
            return {
                ...state,
                token: null,
                me: null
            }
        default:
            return state;
    }
}

export interface AuthReducerState {
    token: string | null;
    me: any;
    error: string
}

export default authReducer;